import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, signInWithEmailAndPassword, signOut, signInWithPopup, browserLocalPersistence, setPersistence } from 'firebase/auth'

// Firebase config (shared with main app)
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Auth and get a reference to the service
export const auth = getAuth(app)

// Set persistence to local (survives browser refresh)
setPersistence(auth, browserLocalPersistence)

// Auth providers
export const googleProvider = new GoogleAuthProvider()

// Configure providers (keep it simple like the main app)
googleProvider.addScope('email')
googleProvider.addScope('profile')

// Auth helper functions
export const loginWithEmail = async (email: string, password: string) => {
  return await signInWithEmailAndPassword(auth, email, password)
}

export const loginWithGoogle = async () => {
  console.log('🔄 Starting Google login...')
  try {
    console.log('🪟 Attempting popup sign-in...')
    const result = await signInWithPopup(auth, googleProvider)
    console.log('✅ Popup sign-in successful:', result.user.email)
    return result
  } catch (error: any) {
    console.error('❌ Google login failed:', error)
    throw error
  }
}

export const logout = async () => {
  await signOut(auth)
}

export default app